import {PartialRouting} from '../partial-routing';

export class RoutingMovies extends PartialRouting {
  constructor(base: string = '') {
    super(base);
  }

  catalogueImport(absolute = false) {
    let prefix = absolute ? '/' : '';
    return `${prefix}${this.getBasePath()}/catalogue-import`;
  }

  catalogueImportRecap(migrationId: string, absolute = false) {
    return `${this.catalogueImport(absolute)}/${migrationId}`;
  }
}
